"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = Notifications;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const uuid = __importStar(require("uuid"));
const react_intl_1 = require("react-intl");
const useConfig_1 = require("@src/hooks/useConfig");
const moment_1 = __importDefault(require("moment"));
const antd_1 = require("antd");
const NotificationItem_1 = require("@src/components/modules/navigation/NotificationItem/NotificationItem");
const Api = __importStar(require("@src/api"));
const Notifications_style_1 = require("./Notifications.style");
const SkeletonItem = () => ((0, jsx_runtime_1.jsx)("div", { className: "p-m", children: (0, jsx_runtime_1.jsx)(antd_1.Skeleton, { avatar: { shape: 'square' }, paragraph: { rows: 3 }, title: false, active: true }) }));
function Notifications({ notifications = [], refetchNotifications, isLoading, skeletonCount }) {
    const config = (0, useConfig_1.useConfig)();
    const markNotificationAsClicked = react_1.default.useCallback(async (notificationId, wasClicked) => {
        try {
            if (!wasClicked) {
                await Api.Account.patchNotification(notificationId, {
                    clicked_at: (0, moment_1.default)().format(config.datetimeFormat),
                });
                refetchNotifications();
            }
        }
        catch (err) {
            console.error(err);
        }
    }, [refetchNotifications]);
    return ((0, jsx_runtime_1.jsxs)(Notifications_style_1.NotificationsWrapper, { children: [notifications.length === 0 && ((0, jsx_runtime_1.jsx)(Notifications_style_1.NoNotificationsMessage, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.notification.no_notifications" }) })), notifications.map(item => ((0, jsx_runtime_1.jsx)(NotificationItem_1.NotificationItem, { notification: item, onClick: () => markNotificationAsClicked(item.uuid, Boolean(item.clicked_at)) }, item.uuid))), isLoading && [...Array(skeletonCount)].map(() => (0, jsx_runtime_1.jsx)(SkeletonItem, {}, uuid.v4()))] }));
}
